export default __webpack_public_path__ + "static/vacations-preview-lgbtq-1-11ee959557e0ad35d466f02334df75ac.jpg";